import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ArticleSection() {
    const defaultImageUrl = "/images/default.png";
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const [articles, setArticles] = useState([]);
    const [pagination, setPagination] = useState({});

    useEffect(() => {
        const fetchArticles = async () => {
            const response = await window.apiClient.get(`/data/article/5/${currentPage}`);
            setArticles(response.data.data);

            if(response.data.data.length > 0){
                if (window.DISQUSWIDGETS) window.DISQUSWIDGETS.getCount();
            }
            setPagination(response.data.pagination);
        };
        fetchArticles();

        const loadDisqusCountScript = () => {
            const d = document, s = d.createElement("script");
            s.id = "dsq-count-scr";
            s.src = "https://osis-sman2amlapura.disqus.com/count.js";
            s.async = true;
            (d.head || d.body).appendChild(s);

            return () => {
                const oldScript = document.getElementById("dsq-count-scr");
                if (oldScript) oldScript.remove();
            };
        };
        const cleanup = loadDisqusCountScript();
        return cleanup;
    }, [currentPage]);

    const handleArticleClick = (code) => {
        navigate(`/article/${code}`);
    };

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <>
            <div className="mb-6 text-center">
                <h2 className="text-3xl font-extrabold tracking-wide text-gray-800 uppercase">
                    Artikel
                </h2>
                <h3 className="text-lg text-gray-500">Latest News from OSIS Smandapura</h3>
            </div>
            <div id="listingartikel" className="space-y-8">
                {articles.map((article) => (
                    <div
                        key={article.id_artikel}
                        className="flex overflow-hidden flex-col bg-white rounded-lg border border-gray-200 shadow-lg transition-transform transform cursor-pointer md:flex-row hover:scale-105 hover:shadow-2xl"
                        onClick={() => handleArticleClick(article.encrypted_id)}
                    >
                        {/* Image */}
                        <div className="overflow-hidden h-48 md:w-1/3 md:h-auto">
                            <img
                                src={article.gambar_artikel
                                    ? `https://admin.sman2amlapura.sch.id/images/artikel/${article.gambar_artikel}`
                                    : defaultImageUrl
                                }
                                loading="lazy"
                                alt={article.judul_artikel}
                                className="object-cover w-full h-full"
                            />
                        </div>

                        {/* Content */}
                        <div className="flex flex-col justify-between p-6 md:w-2/3">
                            <div>
                                <h4 className="mb-2 text-xl font-bold text-gray-800">
                                    {article.judul_artikel}
                                </h4>
                                <p className="overflow-auto text-base leading-relaxed text-gray-600overflow-auto">
                                    {article.konten_artikel}
                                </p>
                            </div>
                            <div className="mt-4 text-sm text-gray-500">
                                <p>
                                    <i className="far fa-calendar"></i> Dibuat: {article.update_date.substring(0, 10)}
                                </p>
                                <i className="far fa-comments"></i> <span className="disqus-comment-count" data-disqus-identifier={article.id_artikel} data-disqus-url={`https://osis.sman2amlapura.sch.id/article/${article.id_artikel}`}>Komentar</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="mt-8">
                <ul className="flex justify-center space-x-2 text-sm font-medium">
                    {Array.from({ length: pagination.total_pages }, (_, index) => (
                        <li
                            key={index + 1}
                            className={`px-4 py-2 rounded-md cursor-pointer hover:bg-blue-600 ${currentPage === index + 1
                                ? "text-white bg-blue-500"
                                : "text-gray-700 bg-gray-300 hover:bg-gray-400"
                                }`}
                            onClick={() => paginate(index + 1)}
                        >
                            {index + 1}
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
}
